module.exports = __webpack_public_path__ + "static/media/dec-netverify-jumio@2x.3ef4879d.png";